import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { OffshoreLevelService } from '../../../../core/services/offshore-level.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessageService } from 'primeng/api';
import { OffshoreLevel } from '../../../../core/models/offshore-level';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ToastModule } from 'primeng/toast';
import { RegexConstants } from '../../../../core/constants/regex-constants';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RequiredMarkDirective } from '../../../../shared/directives/required-mark.directive';

@Component({
  selector: 'em-add-offshore-level',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputNumberModule,
    RadioButtonModule,
    InputTextModule,
    InputTextareaModule,
    ButtonModule,
    ToastModule,
    TranslatePipe,
    RequiredMarkDirective
  ],
  templateUrl: './add-offshore-level.component.html',
  styleUrl: './add-offshore-level.component.scss',
  providers: [MessageService],
})
export class AddOffshoreLevelComponent {
  form!: FormGroup;
  formErrors: any;
  isEditMode: boolean = false;
  isViewMode: boolean = false;
  errorMessages: any = {};
  /*errorMessages: any = {
    required: {
      level: 'layout.configurations.offshoreLevel.addOffshoreLevel.levelIsRequired',
      countsAsOffshore: 'layout.configurations.offshoreLevel.addOffshoreLevel.countsAsOffshoreIsRequired',
      denominationEn: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationnameEn',
      denominationEs: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationnameEs',
      denominationAr: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationnameAr',
      definitionEn: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionnameEn',
      definitionEs: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionnameEs',
      definitionAr: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionnameAr',
    },
    pattern: {
      denominationEn: 'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorEn',
      denominationEs: 'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorEs',
      denominationAr: 'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorAr',
    },
    maxLength: {
      definitionEn: 'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorEn',
      definitionEs: 'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorEs',
      definitionAr: 'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorAr',
    },
  };*/
  translations: any = {};
  originalOffshoreLevel!: OffshoreLevel;
  edited: boolean = false;

  constructor(
    private fb: FormBuilder,
    private offshoreLevelService: OffshoreLevelService,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.loadTranslations();
    this.loadErrorMessages();
    const data = this.config.data;

    this.form = this.fb.group({
      id: [null],
      level: [null, Validators.required],
      countsAsOffshore: [null, Validators.required],
      denomination: [null, Validators.compose([Validators.required, Validators.pattern(RegexConstants.OFFSHORE_DENOMINATION_EN)])],
      denominationEs: [null, Validators.compose([Validators.required, Validators.pattern(RegexConstants.OFFSHORE_DENOMINATION_ES)])],
      denominationAr: [null, Validators.compose([Validators.required, Validators.pattern(RegexConstants.OFFSHORE_DENOMINATION_AR)])],
      definition: [null, Validators.compose([Validators.required, Validators.maxLength(300)])],
      definitionEs: [null, Validators.compose([Validators.required, Validators.maxLength(300)])],
      definitionAr: [null, Validators.compose([Validators.required, Validators.maxLength(300)])],
    });
    
    if (this.config.data) {
       const offshoreLevel = this.config.data.offshoreLevel ?? this.config.data;
       this.isEditMode = true;
       this.originalOffshoreLevel = structuredClone(offshoreLevel);
       this.populateForm(offshoreLevel);
    }
    if (data?.mode === 'view') {
     this.enableViewMode();
   }
    this.translate.onLangChange.subscribe(() => {
      this.loadErrorMessages();
    });
    this.form.valueChanges.subscribe(() => {
      this.edited = true;
    });
  }
    
 

  loadErrorMessages(): void {
    this.translate
      .get([
        'layout.configurations.offshoreLevel.addOffshoreLevel.levelIsRequired',
       'layout.configurations.offshoreLevel.addOffshoreLevel.countsAsOffshoreIsRequired',
       'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationEn',
       'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationEs',
       'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationAr',
       'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionEn',
       'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionEs',
       'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionAr',
       'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorEn',
      'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorEs',
       'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorAr',
      'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorEn',
        'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorEs',
        'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorAr',
      ])
      .subscribe((translations) => {
        this.errorMessages = {
          required: {
            level: 'layout.configurations.offshoreLevel.addOffshoreLevel.levelIsRequired',
           countsAsOffshore: 'layout.configurations.offshoreLevel.addOffshoreLevel.countsAsOffshoreIsRequired',
           denomination: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationEn',
           denominationEs: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationEs',
            denominationAr: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DenominationAr',
           definition: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionEn',
           definitionEs: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionEs',
            definitionAr: 'layout.configurations.offshoreLevel.offshoreLevelValidators.required.DefinitionAr',
      },
      pattern: {
         denomination: 'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorEn',
         denominationEs: 'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorEs',
         denominationAr: 'layout.configurations.offshoreLevel.addOffshoreLevel.denominationErrorAr',
      },
       maxLength: {
        definition: 'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorEn',
        definitionEs: 'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorEs',
       definitionAr: 'layout.configurations.offshoreLevel.addOffshoreLevel.definitionErrorAr',
    },
        };
      });
  }

  loadTranslations() {
    this.translate
      .get([
        'layout.configurations.offshoreLevel.addOffshoreLevel.title',
        'layout.configurations.offshoreLevel.addOffshoreLevel.successMessage.title',
        'layout.configurations.offshoreLevel.editOffshoreLevel.title',
        'layout.configurations.offshoreLevel.editOffshoreLevel.successMessage.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.successMessage.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.message',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.yes',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.no',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.errorMessage.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.errorMessage.detail',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.infoMessage.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.infoMessage.detail',
        'layout.configurations.offshoreLevel.yes',
        'layout.configurations.offshoreLevel.no',
        'layout.configurations.offshoreLevel.addOffshoreLevel.warning.title',
        'layout.configurations.offshoreLevel.addOffshoreLevel.warning.alreadyExists',
        'layout.configurations.offshoreLevel.editOffshoreLevel.warning.alreadyExists',
        'layout.configurations.offshoreLevel.editOffshoreLevel.warning.title',
        'layout.configurations.offshoreLevel.editOffshoreLevel.errorMessage.title',
        'layout.configurations.offshoreLevel.editOffshoreLevel.errorMessage.details',
        'layout.configurations.offshoreLevel.addOffshoreLevel.errorMessage.title',
        'layout.configurations.offshoreLevel.addOffshoreLevel.errorMessage.detail',
        'layout.configurations.offshoreLevel.addOffshoreLevel.successMessage.detail',
      ])
      .subscribe((translations) => {
        this.translations = translations;
      });
  }

  populateForm(offshoreLevel: OffshoreLevel) {
    this.form.patchValue({
      id: offshoreLevel.id,
      level: offshoreLevel.level,
      countsAsOffshore: offshoreLevel.countsAsOffshore,
      denomination: offshoreLevel.denomination,
      denominationEs: offshoreLevel.denominationEs,
      denominationAr: offshoreLevel.denominationAr,
      definition: offshoreLevel.definition,
      definitionEs: offshoreLevel.definitionEs,
      definitionAr: offshoreLevel.definitionAr,
    });
  }

  addOrUpdateOffshoreLevel() {
  if (this.isViewMode) this.enableViewMode();

  if (this.form.invalid) {
    Object.values(this.form.controls).forEach(control => control.markAsTouched());
    return;
  }

  if (this.isEditMode) {
      this.updateOffshoreLevel();
    } else {
      this.addOffshoreLevel();
    }
}

  addOffshoreLevel() {
    const newLevel = this.form.value.level;

    this.offshoreLevelService.getAllOffshoreLevels().subscribe((levels) => {
      const exists = levels.some((level) => level.level === newLevel);

      if (exists) {
        this.messageService.add({
          key: 'main',
          severity: 'warn',
          summary: this.translations['layout.configurations.offshoreLevel.addOffshoreLevel.warning.title'],
          detail: this.translations['layout.configurations.offshoreLevel.addOffshoreLevel.warning.alreadyExists'],
        });
      } else {
        this.offshoreLevelService.addOffshoreLevel(this.form.value).subscribe({
          next: (offshoreLevel: OffshoreLevel) => {
            this.ref.close({ type: 'created', data: offshoreLevel });
          },
          error: (error) => {
            this.formErrors = error.error.fieldErrors;
            this.messageService.add({
              key: 'main',
              severity: 'error',
              summary: this.translations['layout.configurations.offshoreLevel.addOffshoreLevel.errorMessage.title'],
              detail: this.translations['layout.configurations.offshoreLevel.addOffshoreLevel.errorMessage.detail'],
            });
          },
        });
      }
    });
  }

  updateOffshoreLevel() {
    const newLevel = this.form.value.level;
  const isChanged = JSON.stringify(this.originalOffshoreLevel) !== JSON.stringify(this.form.value);
  if (!isChanged) {
      this.ref.close({ type: 'no-change' });
      return;
    }

    this.offshoreLevelService.getAllOffshoreLevels().subscribe((levels) => {
      const levelExists = levels.some((level) => level.level === newLevel && level.id !== (this.form.value).id);

      if (levelExists) {
        this.messageService.add({
          severity: 'warn',
          summary: this.translations['layout.configurations.offshoreLevel.editOffshoreLevel.warning.title'],
          detail: this.translations['layout.configurations.offshoreLevel.editOffshoreLevel.warning.alreadyExists'],
        });
        return;
      }

      this.offshoreLevelService.updateOffshoreLevel(this.form.value).subscribe({
        next: (offshoreLevel: OffshoreLevel) => {
          this.ref.close({ type: 'updated', data: offshoreLevel });
        },
        error: (error) => {
          this.formErrors = error.error.fieldErrors;
          this.messageService.add({
            key: 'main',
            severity: 'error',
            summary: this.translations['layout.configurations.offshoreLevel.editOffshoreLevel.errorMessage.title'],
            detail: this.translations['layout.configurations.offshoreLevel.editOffshoreLevel.errorMessage.detail'],
          });
        },
      });
    });
  }

  isInvalid(key: string) {
    const control = this.form.get(key);

    return {
      invalid: control?.invalid && (control?.dirty || control?.touched),
      message:
        control?.errors &&
        (control.errors['required']
          ? this.errorMessages.required[key]
          : control?.errors['pattern']
            ? this.errorMessages.pattern[key]
            : this.errorMessages.maxLength[key]),
    };
  }

  getErrorMessage(field: string) {
    return this.formErrors?.find((obj: { field: string }) => obj.field == field)?.errorMessage || '';
  }
  enableViewMode() {
  this.isViewMode = true;
  this.form.disable({ emitEvent: false });
}
}
